import {gql} from "@apollo/client";
import moment from "moment";
import qs from "query-string";


export type CustomsRequirement = {
    date: string
    number: string
    screeningType: "Физический" | "МИДК" | "Взвешивание"
    status: "Завершен" | "В работе" | "Отменен"
    numberCTR: string
    billOfLanding: string
    screeningDate: string
    screeningDeep: number
}


export const GetCustomsRequirementListDocument = gql`
    query GetCustomsRequirementList($dateFrom: Date, $dateTo: Date, $screeningType: String, $page: String, $query: String) {
        customsRequirements(date_from: $dateFrom, date_to: $dateTo, screening_type: $screeningType, page: $page, query: $query) 
        @rest(pathBuilder: $pathBuilder) {
            customsRequirements @type(name: "CustomsRequirement") {
                id: number
                date
                number
                numberCTR
                screeningType
                screeningDate
                screeningDeep
                billOfLanding
                status
            }
            pageInfo {
                countItems
                nextPage
                pageSize
            }
        }
    }
`;


export function customsRequirementListPathBuilder({args}) {
    const url = "remote/erp/api/v2/customs-requirements/";
    const params = {
        offset: "20"
    };
    const format = "YYYY-MM-DD";
    if (args.date_from) {
        params["date-from"] = moment(args.date_from).format(format);
    }
    if (args.date_to) {
        params["date-to"] = moment(args.date_to).format(format);
    }
    if (args.screening_type) {
        params["scr-type"] = args.screening_type;
    }
    if (args.page) {
        params["page"] = args.page;
    }
    if (args.query) {
        params["query"] = args.query;
    }
    return url + "?" + qs.stringify(params);
}


export type GetCustomsRequirementListQueryVars = {
    page?: string
    dateFrom?: number,
    dateTo?: number,
    screeningType?: CustomsRequirement["screeningType"]
    query?: string
    pathBuilder: typeof customsRequirementListPathBuilder
}

export type GetCustomsRequirementListQueryResult = {
    customsRequirements: {
        customsRequirements: CustomsRequirement[]
        pageInfo: {
            countItems: number
            nextPage: string
            pageSize: number
        }
    }
}
